const Loader = () => (
  <div className="absolute inset-0 flex items-center justify-center bg-gray-900">
    <span className="animate-spin h-12 w-12 mt-1 border-4 border-t-transparent border-purple-500 rounded-full"></span>
  </div>
);

export default Loader;
